<template>
<div>
    <!--<common-nav></common-nav>-->
    <transition>
        <router-view></router-view>
    </transition>
</div>
</template>

<script>
//import MockData from '../src/test/mockData';
export default {
    beforeCreate() {
        this.$store.dispatch('getUser');
        this.$store.dispatch('getStatus');
    },
    beforeMount() {
//        MockData();
    }
}
</script>

<style lang="sass">@import '../theme/index.css';
@import "../sass/_reset.scss";</style>



// WEBPACK FOOTER //
// App.vue?45f88732